<template>
  <nx-tabs v-if="tabs.length > 0"
           :value="selectedChannel"
           :tabs="tabs"
           @input="editChannel"
           color="transparent"
           :disabled="disabled">
    <v-menu v-if="hasAvailableActions" class="tabs__div" :disabled="disabled">
      <v-btn icon class="tabs__item" slot="activator">
        <v-icon>more_vert</v-icon>
      </v-btn>
      <v-list
          dense
          left>
        <v-list-tile
            :key="`${index}-${item.action}`"
            @click="dispatchAction(item)"
            v-for="(item, index) in actions"
            v-if="item.action === 'addChannel'"
        >
          <v-list-tile-action>
            <v-icon>add</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>
            {{ $t(`message.content.editor.addChannel.${item.channel}`) }}
          </v-list-tile-title>
        </v-list-tile>
        <v-divider v-else-if="item.divider && index !== 0" :key="index"></v-divider>
        <v-list-tile
            v-else-if="item.action === 'removeChannel'"
            @click="dispatchAction(item)"
        >
          <v-list-tile-action>
            <v-icon>delete</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>
            {{ $t(`message.content.editor.deleteChannel.${item.channel}`) }}
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </nx-tabs>
</template>

<script>
import Storable from '@/mixins/storable';
import NxTabs from '@/components/Tabs';

export default {
  name: 'nx-content-editor-channel-tabs',
  mixins: [Storable],
  components: {
    NxTabs,
  },
  props: {
    editorStorePath: {
      type: [String, Array],
      required: true,
    },
  },
  computed: {
    storePath() {
      return this.editorStorePath;
    },
    actions() {
      const addChannels = this.availableChannels
        .filter(channel => !channel.includes('translation'))
        .map(channel => ({ channel, action: 'addChannel' }));

      const removeChannels = this.modifiedChannels
        .filter(channel => channel !== 'master')
        .filter(channel => !channel.includes('translation'))
        .map(channel => ({ channel, action: 'removeChannel' }));

      if (addChannels.length === 0
        && removeChannels.length === 0) {
        // No available actions
        return [];
      }

      if (addChannels.length > 1
        && removeChannels.length > 1) {
        // Multiple actions, add a divider
        return addChannels
          .concat([{ divider: true }], removeChannels);
      }

      return addChannels.concat(removeChannels);
    },
    hasAvailableActions() {
      return this.actions.length > 0;
    },
    modifiedChannels() {
      return this.getters.modifiedChannels;
    },
    availableChannels() {
      return this.getters.availableChannels;
    },
    mandatoryFieldsErrors() {
      return this.getters.mandatoryFieldsErrors;
    },
    currentChannel() {
      return this.state.currentChannel;
    },
    selectedChannel() {
      if (this.currentChannel.includes('translation')) {
        return 'master';
      }
      return this.currentChannel;
    },
    disabled() {
      return this.mandatoryFieldsErrors && this.mandatoryFieldsErrors.length > 0;
    },
    tabs() {
      return this.modifiedChannels
        .filter(channel => !channel.includes('translation'))
        .map(channel => ({ id: channel, label: this.$t(`message.content.editor.channel.${channel}`) }));
    },
  },
  methods: {
    dispatchAction(item) {
      if (item.action === 'addChannel') {
        this.addChannel(item.channel);
      } else if (item.action === 'removeChannel') {
        this.removeChannel(item.channel);
      }
    },
    addChannel(channel) {
      this.$emit('add', channel);
    },
    removeChannel(channel) {
      this.$emit('remove', channel);
    },
    editChannel(channel) {
      this.$emit('edit', channel);
    },
  },
};
</script>
